import { JoonUIColor } from "@joonapp/web-shared"
import { useEffect, useRef } from "react"

import ActiveScreenTimeSection from "./ActiveScreenTimeSection"
import { AddRewardButton } from "./AddRewardButton"
import { useRewardPageStore } from "./hooks/useRewardPageStore"
import { useShowInitialScreenTimeControlsModal } from "./hooks/useShowInitialScreenTimeControlsModal"
import { useShowScreenTimeRestrictionFTUXModal } from "./hooks/useShowScreenTimeRestrictionFTUXModal"
import RewardsRedeem from "./RewardsRedeem"
import RewardsUserSelectHeader from "./RewardsUserSelectHeader"
import RewardTemplates from "./RewardTemplates"
import ScreenTimeRestrictionFTUXModal from "./ScreenTimeRestrictionFTUXModal"
import WelcomeCustomRewards from "./WelcomeCustomRewards"
import PageContentWrapper from "../../components/pageContentWrapper/PageContentWrapper"
import PageHeaderWrapper from "../../components/pageHeaderWrapper/PageHeaderWrapper"
import PageWrapper from "../../components/pageWrapper/PageWrapper"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import { requireAuth } from "../../util/auth"
import { localStorageItems } from "../../util/storage"

const RewardsPage = () => {
  const pageWrapperRef = useRef<HTMLDivElement>(null)
  useDocumentTitle("Joon - Rewards")
  const { showWelcome, setShowWelcome } = useRewardPageStore()

  // Show the initial screen time controls modal if the user has not seen it yet
  useShowInitialScreenTimeControlsModal()
  // Show Screen Time Restriction FTUX modal if the user has not seen it yet
  useShowScreenTimeRestrictionFTUXModal()

  useEffect(() => {
    setShowWelcome(
      !!localStorage.getItem(localStorageItems.needsToSeeWelcomeRewards)
    )
  }, [setShowWelcome])

  useEffect(() => {
    if (pageWrapperRef.current) {
      pageWrapperRef.current.scrollTo({ top: 0, behavior: "instant" })
    }
  }, []) // eslint-disable-line

  if (showWelcome) return <WelcomeCustomRewards />

  return (
    <PageWrapper
      style={{ background: JoonUIColor.background.xlightGray }}
      ref={pageWrapperRef}
    >
      <PageHeaderWrapper>
        <RewardsUserSelectHeader />
      </PageHeaderWrapper>
      <PageContentWrapper mobileGutter>
        <ActiveScreenTimeSection />
        <RewardsRedeem />
      </PageContentWrapper>
      <AddRewardButton />
      <RewardTemplates />
      <ScreenTimeRestrictionFTUXModal />
    </PageWrapper>
  )
}

const RewardsPageWithAuth = requireAuth(RewardsPage)
export default RewardsPageWithAuth
